import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { clearUserSession } from '../../../utils/AccountsStorageUtils';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

interface UseGetUserLogoutAPIInterface {
  userLogoutAPI: UseMutateAsyncFunction<void, unknown, void, unknown>;
  error: string;
  status: MutationStatus;
}

const useGetUserLogoutAPI = (): UseGetUserLogoutAPIInterface => {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const getUserLogout = () => {
    return ibUserAccountsAPIService
      .userLogout()
      .then(() => {
        clearUserSession();
      })
      .catch(() => clearUserSession());
  };

  const { mutateAsync, error, status } = useMutation(getUserLogout, {
    mutationKey: ['userLogoutAPI']
  });

  return {
    userLogoutAPI: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useGetUserLogoutAPI };
